<div class="docu-header-folders-container">
  <div class="docu-header-folders-label">Mallar i andra kategorier:</div>
  <app-docu-folder-list
    [docuRoot]="docuRoot"
    [folders]="folders | async"
  ></app-docu-folder-list>
</div>
